import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function IntegrationInstructionsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"integration_instructions"}/>
}
